import { Box } from '@mui/material';
import { useState } from 'react';
import {
  InputProps,
  NumberInput,
  required,
  TextInput,
  WrapperField,
} from 'react-admin';
// Removed useEffect
import { useFormContext } from 'react-hook-form';
import { IntegrationRecord } from '../../../common/types';
import IntegrationInfo from './IntegrationInfo';
import StyledBooleanInput from './StyledBooleanInput';

const UnifocusInputs = ({
  integration,
}: Omit<InputProps, 'source'> & { integration: IntegrationRecord }) => {
  const { setValue, getValues } = useFormContext();

  const [useFulfillmentTime, setUseFulfilmentTime] = useState(() => {
    // Initialize based on whether fulfillmentAdvanceMinutes has a value
    const currentMinutes = getValues(
      'currentConfig.service.fulfillmentAdvanceMinutes'
    );

    return !!currentMinutes;
  });

  const handleToggleChange = (event: any) => {
    const isChecked = event.target.checked;
    setUseFulfilmentTime(isChecked);
    const minutesPath = 'currentConfig.service.fulfillmentAdvanceMinutes';

    if (!isChecked) {
      setValue(minutesPath, null);
    } else {
      // If turning ON, only set to 0 if it doesn't already have a value.
      const currentMinutes = getValues(minutesPath);
      if (currentMinutes === null || currentMinutes === undefined) {
        setValue(minutesPath, 0);
      }
    }
  };

  return (
    <WrapperField>
      <IntegrationInfo integration={integration} />
      <Box width="70%" maxWidth="70%">
        <TextInput
          source="currentConfig.service.apiEndpointUrl"
          label="resources.integrations.fields.unifocus.api_endpoint_url.label"
          helperText="resources.integrations.fields.unifocus.api_endpoint_url.helperText"
          validate={required(
            'resources.integrations.fields.unifocus.api_endpoint_url.helperText'
          )}
          variant="outlined"
          fullWidth
        />
        <TextInput
          source="currentConfig.service.propertyId"
          label="resources.integrations.fields.unifocus.property_id.label"
          helperText="resources.integrations.fields.unifocus.property_id.helperText"
          validate={required(
            'resources.integrations.fields.unifocus.property_id.helperText'
          )}
          variant="outlined"
          fullWidth
        />
        <TextInput
          source="currentConfig.service.publicKey"
          label="resources.integrations.fields.unifocus.public_key.label"
          helperText="resources.integrations.fields.unifocus.public_key.helperText"
          validate={required(
            'resources.integrations.fields.unifocus.public_key.helperText'
          )}
          variant="outlined"
          fullWidth
        />
        <TextInput
          source="currentConfig.service.privateKey"
          label="resources.integrations.fields.unifocus.private_key.label"
          helperText="resources.integrations.fields.unifocus.private_key.helperText"
          validate={required(
            'resources.integrations.fields.unifocus.private_key.helperText'
          )}
          variant="outlined"
          fullWidth
        />
        <TextInput
          source="currentConfig.service.timezone"
          label="resources.integrations.fields.unifocus.timezone.label"
          helperText="resources.integrations.fields.unifocus.timezone.helperText"
          validate={required(
            'resources.integrations.fields.unifocus.timezone.helperText'
          )}
          variant="outlined"
          fullWidth
        />
        <TextInput
          source="currentConfig.service.applicationId"
          label="resources.integrations.fields.unifocus.application_id.label"
          helperText="resources.integrations.fields.unifocus.application_id.helperText"
          variant="outlined"
          fullWidth
        />

        <StyledBooleanInput
          source=""
          label="resources.integrations.fields.unifocus.use_fulfillment_time.label"
          helperText="resources.integrations.fields.unifocus.use_fulfillment_time.helperText"
          variant="outlined"
          checked={useFulfillmentTime}
          onChange={handleToggleChange}
        />

        {useFulfillmentTime && (
          <NumberInput
            source="currentConfig.service.fulfillmentAdvanceMinutes"
            label="resources.integrations.fields.unifocus.fulfillment_advance_minutes.label"
            helperText="resources.integrations.fields.unifocus.fulfillment_advance_minutes.helperText"
            variant="outlined"
            fullWidth
            defaultValue={0}
          />
        )}
      </Box>
    </WrapperField>
  );
};

export default UnifocusInputs;
